import axios from "../../api/axiosInstance";
import { STATUS, extractErrorInfo } from "./sharedfunction";

export async function login({ email, password } = {}) {
  try {
    if (!email || !password) {
      return {
        status: STATUS.ERROR,
        error: "Email and password are required",
      };
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/login`,
      {
        email,
        password,
      },
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error logging in:", error);
    return extractErrorInfo(error);
  }
}

export async function verifyMfaLogin({ mfaToken, otp } = {}) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/login/mfa/verify`,
      { mfaToken, otp },
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

export async function resendMfaLogin({ mfaToken } = {}) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/login/mfa/resend`,
      { mfaToken },
      { withCredentials: true }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}

export async function logout() {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/auth/logout`,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error logging out:", error);
    return extractErrorInfo(error);
  }
}

export async function getCurrentLoggedInUser() {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/auth/getCurrentLoggedInUser`,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching current user:", error);
    return extractErrorInfo(error);
  }
}

export async function refreshSession() {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth/refreshSession`,
      {},
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error refreshing session:", error);
    return extractErrorInfo(error);
  }
}

